import React, { ReactNode } from 'react';
import styled from 'styled-components';
import TrueImpactText from '../../base/TrueImpactText';
import { COLORS } from '../../settings/variables/Colors';
import { SPACERS } from '../../settings/variables/Spacers';

interface RadiobuttonProps {
  text: ReactNode;
  check: boolean;
  onClick: () => unknown;
  className?: string;
  radioClassName?: string;
  textClassName?: string;
}

const StyledButton = styled.button`
  border: none;
  display: flex;
  cursor: pointer;
  align-items: center;
  background-color: inherit;
  padding-top: ${SPACERS.tiny};
  padding-bottom: ${SPACERS.tiny};
`;

const StyledSingleRadioButton = styled.div<{ check: boolean }>`
  width: 20px;
  height: 20px;
  display: flex;
  margin-right: ${SPACERS.tiny};
  align-items: center;
  justify-content: center;
  .radio {
    width: 100%;
    height: 100%;
    border-radius: 100%;
    background-color: inherit;
    transition: border 0.3s;
    outline: 2px solid
      ${({ check }) => (check ? COLORS.ctaPrimary : COLORS.grayDark)};
    border: 6px solid ${({ check }) => (check ? COLORS.ctaPrimary : 'inherit')};
  }
`;

export const SingleRadioButton: React.FC<{
  check: boolean;
  className?: string;
}> = ({ check, className }) => {
  return (
    <StyledSingleRadioButton check={check} className={className}>
      <div className="radio" />
    </StyledSingleRadioButton>
  );
};

const Radiobutton: React.FC<RadiobuttonProps> = ({
  check,
  text,
  onClick,
  className,
  radioClassName,
  textClassName,
}) => {
  return (
    <StyledButton className={className} onClick={onClick}>
      <SingleRadioButton check={check} className={radioClassName} />
      <TrueImpactText className={textClassName}>{text}</TrueImpactText>
    </StyledButton>
  );
};

export default Radiobutton;
